import React from 'react';

import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    Skeleton,
    Stack,
} from '@mui/material';

const CardSkeleton = () => {
    return (
        <Grid container spacing={2}>
            {Array.from(new Array(2)).map((_, index) => (
                <Grid item xs={12} sm={6} md={6} key={index}>
                    <Card
                        variant="outlined"
                        sx={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)' }}
                    >
                        <CardContent sx={{ flexGrow: 1 }}>
                            <Skeleton
                                variant="text"
                                height={30}
                                width="80%"
                                sx={{ mb: 2 }}
                            />
                            <Skeleton variant="text" height={20} width="100%" />
                            <Skeleton
                                variant="text"
                                height={20}
                                width="100%"
                                sx={{ mb: 4 }}
                            />
                        </CardContent>

                        {/* Footer with 3 spaced items */}
                        <Box
                            sx={{
                                // backgroundColor: theme.palette.primary.light,
                                px: 2,
                                py: 1.5,
                                borderTop: `1px solid #ccc`,
                            }}
                        >
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={2}
                            >
                                {[...Array(3)].map((_, index) => (
                                    <Box
                                        key={index}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <Skeleton
                                            variant="circular"
                                            width={16}
                                            height={16}
                                        />
                                        <Skeleton
                                            variant="text"
                                            width={60}
                                            height={16}
                                        />
                                    </Box>
                                ))}
                            </Stack>
                        </Box>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default CardSkeleton;
